import TerminalStrip from "../../models/TerminalStrip";
import { SequenceStep, enumActions } from "../Guide";
import { ToDoItem } from "../ToDoItem";
import guideSequence_addActorElcbTerminalStrip from "./guideSequence_addActorElcbTerminalStrip";

// ContextMenuLables.addFloors
function sequence(type: string, lastToDoItem?: ToDoItem): Array<SequenceStep> {
  let firstTerminakStrip: TerminalStrip | undefined = state.cabinets.sortBy("tag")[0]?.terminalStrips.sortBy("tag")[0];

  return [
    {
      action: enumActions.call,
      subSequence: () => {
        if (!firstTerminakStrip) {
          return [...guideSequence_addActorElcbTerminalStrip("TerminalStrip")]; // no itx
        } else {
          return [];
        }
      },
    },
    {
      action: enumActions.function,
      func: async (): Promise<void> => {
        firstTerminakStrip = state.cabinets.sortBy("tag")[0]?.terminalStrips.sortBy("tag")[0];
        state.selectionManager.selectedObject = firstTerminakStrip;
      },
    },
    {
      action: enumActions.wait,
    },
    {
      action: enumActions.focus,
      id: () => {
        return `tv-${firstTerminakStrip?.id}`;
      },
    },
    {
      action: enumActions.click,
      id: () => {
        return [`tv-${firstTerminakStrip?.id}`, `ContextMenuLables_addTerminal`];
      },
    },

    // {
    //   action: enumActions.explain,
    //   text: "Eine neue Klemme wurd in der Klemmleiste T1 erstellt".replace("T1", firstTerminakStrip?.fullname || ""),
    // },
  ];
}

export default sequence;
